import React from 'react';
import stylesPlain from '../../components/plain/plain.module.css';

import PlainPage from '../../components/plain/PlainPage';
import LabelField from '../../components/plain/LabelField';
import FieldEnum from '../../components/plain/FieldEnum';
import FieldString from '../../components/plain/FieldString';
import FieldDecimal from '../../components/plain/FieldDecimal';
import FieldReference from '../../components/plain/FieldReference';
import FieldList_CardsPanel from '../../components/plain/FieldList_CardsPanel';
import FieldList_Strings from '../../components/plain/FieldList_Strings';
import DivLocationList from './components/DivLocationList';

import {getDefinedValue} from '../../util/tools';
import {FORM_EVENT_PLAIN, FORM_AUTHORITY_AUTHOR_TABLE, FORM_AUTHORITY_PUBLISHER_TABLE} from '../../util/consts/forms';
import {CLASS_EVENT, CLASS_AUTHORITY_AUTHOR, CLASS_AUTHORITY_PUBLISHER} from '../../util/consts/classes';
import {AUTHORITY_AUTHOR_PATH, AUTHORITY_PUBLISHER_PATH} from '../../util/routes';
import { 
	ENUMERATION_LANGUAGE,
	ENUMERATION_TEXT_FORMAT,
	ENUMERATION_EVENT_TYPE,
} from '../../util/consts/common';

class EventPlainPage extends PlainPage { 
	
	enumLanguage = null;
	enumTextFormat = null;
	enumEventType = null;
	
	constructor(props) {
		super(props);
		this.formPath = FORM_EVENT_PLAIN;
		this.formTitle = 'Подія';
		this.buildInstanceCard = this.buildEventCard;
	}
	componentDidMount = async () => {
		this.init(CLASS_EVENT)
		document.title = 'BOM. ' + this.formTitle;
	}
	completeInit() {
		this.enumLanguage = this.realm.getEnumeration( ENUMERATION_LANGUAGE );
		this.enumTextFormat = this.realm.getEnumeration( ENUMERATION_TEXT_FORMAT );
		this.enumEventType = this.realm.getEnumeration( ENUMERATION_EVENT_TYPE );
		
		return true;
	}
	
	buildEventCard = (eventInstance) => {
		let card = '';

		let eventType = eventInstance.rootField.value.type.value;
		if( eventType ) {
			let eventTypeText = this.realm.getEnumerationItemText( this.enumEventType, eventType);
			card += eventTypeText + ': ';
		}
		card += getDefinedValue(eventInstance.rootField.value.name.value, '');
		
		return card;
	}

	descriptionCardBuilder = (fieldDescription, index) => {
		let lang = this.realm.getEnumerationItemText(this.enumLanguage, fieldDescription.value.language.value)
		let format = this.realm.getEnumerationItemText(this.enumTextFormat, fieldDescription.value.format.value)
		let card = lang + ' (' + format + ')';
		if( fieldDescription.value.content.value )
			card += ': ' + fieldDescription.value.content.value;
		if( card.length > 80 )
			card = card.substring(0, 77) + '...';
		return card;
	}
	
	locationCardBuilder = (fieldLocation, index) => {
		let lang = this.realm.getEnumerationItemText(this.enumLanguage, fieldLocation.value.language.value)
		let card = lang + ' ';
		if( fieldLocation.value.dates.value )
			card += ': ' + fieldLocation.value.dates.value;
		if( card.length > 80 )
			card = card.substring(0, 77) + '...';
		return card;
	}

	renderBody() {
		let instance = this.state.instance;
		let refRecordNodes = [
			{
				classId: CLASS_AUTHORITY_AUTHOR, plainFormPath: AUTHORITY_AUTHOR_PATH, 
				selectInstanceFormId: FORM_AUTHORITY_AUTHOR_TABLE,
				selectInstanceFormTitle: 'Автори'
			},
			{
				classId: CLASS_AUTHORITY_PUBLISHER, plainFormPath: AUTHORITY_PUBLISHER_PATH, 
				selectInstanceFormId: FORM_AUTHORITY_PUBLISHER_TABLE,
				selectInstanceFormTitle: 'Бренди'
			}
		]
		return (
			<div className={stylesPlain.divPlainMain}>
				{this.renderHeader()}
				
				{/* Body */}
				<div className={stylesPlain.divPlainBody} >
					
					{/*Date, type */}
					<div style={{display: 'flex', alignItems: 'center'}}>
						<FieldString instance={instance} path={'/dates'} plain={this} 
							styles={{ input: {width: '200px', flexGrow: '1', marginRight: '20px'} }}
						/>
						<FieldEnum instance={instance} path={'/type'} plain={this} 
							styles={{ select: {flexGrow: '1'}}} 
						/>
					</div>
					
					{/*Name */}
					<div style={{display: 'flex', alignItems: 'center', marginTop: '10px'}}>
						<FieldString instance={instance} path={'/name'} plain={this} 
							styles={{ input: {flexGrow: '1'} }}
						/>
					</div>

					<FieldList_CardsPanel instance={instance} path={'/descrList'} plain={this} 
						itemComponent={EventDescriptionPanel} itemCardBuilder={this.descriptionCardBuilder}
						labelEmptyToHeader={true}
						styles={{
							divMainStyle: {
								marginTop: '10px',
								padding: '10px 10px 10px 10px',
								backgroundColor: 'rgb(200,200,200)',
								border: '1px solid blue'
							},
							divCardsBlock: {
								marginRight: '10px',
								maxWidth: '350px',
								backgroundColor: 'rgb(200,200,200)',
							},
							divCard: {
								marginTop: '3px',
								padding: '7px',
								cursor: 'pointer',
								backgroundColor: 'rgb(230,230,230)',
								minHeight: '18px'
							}
						}}
					/>

					<div style={{}}>
						<DivLocationList instance={instance} path={'/locations'} plain={this} 
							ignoreTitle={false}
						/>
					</div>

					{/*
					<FieldList_CardsPanel instance={instance} path={'/locations'} plain={this} 
						itemComponent={EventLocationPanel} itemCardBuilder={this.locationCardBuilder}
						labelEmptyToHeader={true}
						styles={{
							divMainStyle: {
								marginTop: '10px',
								padding: '10px 10px 10px 10px',
								backgroundColor: 'rgb(200,200,200)',
								border: '1px solid blue'
							},
							divCardsBlock: {
								marginRight: '10px',
								maxWidth: '350px',
								backgroundColor: 'rgb(200,200,200)',
							},
							divCard: {
								marginTop: '3px',
								padding: '7px',
								cursor: 'pointer',
								backgroundColor: 'rgb(230,230,230)',
								minHeight: '18px'
							}
						}}
					/>
					*/}
					<div style={{marginTop: '20px'}}>
						<FieldReference instance={instance} path={'/recordRef'} plain={this}
							refNodes={refRecordNodes} 
						/>
					</div>
				</div>
			</div>
		)
	}
}

class EventDescriptionPanel extends React.Component {

	/*
		plain
		fieldGroup
		listItemInfo
	*/
	constructor(props) {
		super(props);
	}
	
	render() {
		let fieldGroup = this.props.fieldGroup;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let readOnly = plain.instanceReadOnly;
		
		// content, format, language, uri
		return (
			<div style={{flexGrow: '1', backgroundColor: 'lightGray'}}>
				<div style={{margin: '10px', padding: '10px', border: '1px solid gray'}}>
					<div style={{display: 'flex', alignItems: 'center'}}>
						<FieldEnum instance={instance} path={'language'} parentField={fieldGroup} plain={plain} readOnly={readOnly} 
							styles={{ select: {flexGrow: '1', marginRight: '20px'} }}
						/>
						<FieldEnum instance={instance} path={'format'} parentField={fieldGroup} plain={plain} readOnly={readOnly} 
							styles={{ select: {flexGrow: '1'} }}
						/>
					</div>
					<div style={{marginTop: '10px'}}>
						<LabelField  instance={instance} path={'content'} parentField={fieldGroup} />
					</div>
					<div>
						<FieldString instance={instance} path={'content'} parentField={fieldGroup} plain={plain} readOnly={readOnly}
							multiline={true} rows={5} cols={60} styleInput={{width: '99%'}}
						 />
					</div>
					<div style={{marginTop: '10px'}}>
						<FieldList_Strings  instance={instance} path={'uri'} parentField={fieldGroup} plain={plain} readOnly={readOnly}
							labelEmptyToHeader={true}
						/>
					</div>
				</div>
			</div>
		)
	}
}

class EventLocationPanel extends React.Component {

	/*
		plain
		fieldGroup
		listItemInfo
	*/
	constructor(props) {
		super(props);
	}
	
	render() {
		let fieldGroup = this.props.fieldGroup;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let readOnly = plain.instanceReadOnly;
		
		// content, format, language, uri
		return (
			<div style={{flexGrow: '1', backgroundColor: 'lightGray'}}>
				<div style={{margin: '10px', padding: '10px', border: '1px solid gray'}}>
					<div style={{display: 'flex', alignItems: 'center'}}>
						<FieldEnum instance={instance} path={'role'} parentField={fieldGroup} plain={plain} readOnly={readOnly} 
							styles={{ select: {marginRight: '20px'} }}
						/>
						<FieldString instance={instance} path={'/dates'} plain={this} 
							styles={{ input: {width: '150px', flexGrow: '1', marginRight: '20px'} }}
						/>
						<FieldEnum instance={instance} path={'language'} parentField={fieldGroup} plain={plain} readOnly={readOnly} 
						/>
					</div>
					<div style={{display: 'flex', marginTop: '20px', alignItems: 'center'}}>
						<FieldEnum instance={instance} path={'country'} parentField={fieldGroup} plain={plain} readOnly={readOnly} 
							styles={{ select: {marginRight: '20px', width: '150px'} }}
						/>
						<FieldString instance={instance} path={'/index'} parentField={fieldGroup} plain={this} readOnly={readOnly} 
							styles={{ input: {width: '150px', flexGrow: '1', marginRight: '20px'} }}
						/>
						<FieldEnum instance={instance} path={'area'} parentField={fieldGroup} plain={plain} readOnly={readOnly} 
							styles={{ select: {marginRight: '20px', width: '150px'} }}
						/>
						<FieldString instance={instance} path={'/region'} parentField={fieldGroup} plain={this} readOnly={readOnly} 
							styles={{ input: {width: '150px', flexGrow: '1'} }}
						/>
					</div>
					<div style={{display: 'flex', marginTop: '20px', alignItems: 'center'}}>
						<FieldString instance={instance} path={'/place'} parentField={fieldGroup} plain={this} readOnly={readOnly} 
							styles={{ input: {width: '300px', flexGrow: '1', marginRight: '20px'} }}
						/>
						<FieldDecimal instance={instance} path={'/latitude'} parentField={fieldGroup} plain={this} readOnly={readOnly} 
							styles={{ input: {width: '60px', flexGrow: '1', marginRight: '20px'} }}
						/>
						<FieldDecimal instance={instance} path={'/longitude'} parentField={fieldGroup} plain={this} readOnly={readOnly} 
							styles={{ input: {width: '60px', flexGrow: '1'} }}
						/>
					</div>
					<div style={{marginTop: '10px'}}>
						<LabelField  instance={instance} path={'comment'} parentField={fieldGroup} />
					</div>
					<div>
						<FieldString instance={instance} path={'comment'} parentField={fieldGroup} plain={plain} readOnly={readOnly}
							multiline={true} rows={5} cols={60} styleInput={{width: '99%'}}
						 />
					</div>
				</div>
			</div>
		)
	}
}
export default EventPlainPage;
